<div class="host-search-houses-with-group-and-type">
  <div
    class="filter"
    [ngClass]="{ bordered: !noBorder, 'no-border': noBorder }"
    [style.padding-left]="filterBigPadding ? '24px' : '12px'"
    [style.padding-right]="filterBigPadding ? '24px' : '12px'"
    [style.width]="showWidth"
  >
    <div *ngIf="houseTypeList.length === 0" class="only-groups">
      <div
        class="group-basic"
        [ngClass]="{
          group: !group.thisGroupChecked,
          'group-selected': group.thisGroupChecked
        }"
        *ngFor="let group of houseGroupList; index as i"
        (click)="checkGroup(i)"
      >
        {{ group?.name }}
      </div>
    </div>
    <div *ngIf="houseTypeList.length !== 0" class="groups-and-types">
      <div class="groups">
        <div
          class="group-basic"
          [ngClass]="{
            group: !group.thisGroupChecked,
            'group-selected': group.thisGroupChecked
          }"
          *ngFor="let group of houseGroupList; index as i"
          (click)="checkGroup(i)"
        >
          {{ group?.name }}
        </div>
      </div>
      <div class="types">
        <div
          class="group-basic"
          [ngClass]="{
            group: !type.thisTypeChecked,
            'group-selected': type.thisTypeChecked
          }"
          *ngFor="let type of houseTypeList; index as i"
          (click)="checkType(i)"
        >
          {{ type?.title }}
        </div>
      </div>
    </div>
  </div>
  <div
    class="houses-in-types"
    [ngClass]="{ bordered: !noBorder, 'no-border': noBorder }"
    [style.padding-left]="filterBigPadding ? '24px' : '16px'"
    [style.padding-right]="filterBigPadding ? '24px' : 0"
    [style.width]="showWidth"
  >
    <div class="houses-container" [style.max-height]="showHouseHeight">
      <div *ngIf="allHouseList.length > 0; else empty">
        <div class="house-in-one-type" *ngFor="let houseType of allHouseList">
          <p *ngIf="allHouseList.length !== 1">
            {{ houseType?.house_type_title }}
          </p>
          <div class="houses">
            <div
              [ngClass]="{
                disabled: house.disabled,
                house: !house.disabled && !house.checked,
                checked: !house.disabled && house.checked
              }"
              *ngFor="let house of houseType?.houses"
              (click)="chooseHouse(house)"
            >
              {{ house?.house_title }}
            </div>
          </div>
        </div>
      </div>
      <ng-template #empty>
        <div class="empty">
          <img class="host-no-data-img-small" src="/assets/icon/no_data.png" />
          <p>
            <!-- 暂无房间 -->
            {{ "house_price.no_house" | translate }}
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
